import React from "react";
import Calendar from "react-calendar/dist/entry.nostyle";
import moment from "moment";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import { getFallbackLocale } from "utils/locale";
import Translate from "utils/translate";

import { DateTimeHeader, TimePicker } from ".";

import styles from "./DateTimePicker.css";

const isToday = (date) => date.getDate() === moment().date();

const { t } = new Translate("DateTime");

const DateTimePicker = (props) => {
  const { date, isTimeHidden, onChange, onClose, onReset, onSave, time, title } = props;

  return (
    <div className={styles.root}>
      <DateTimeHeader
        date={date}
        isLarge={!isTimeHidden}
        onClose={onClose}
        onReset={onReset}
        title={title}
      />
      <div className={styles.body}>
        <Calendar
          locale={getFallbackLocale()}
          minDetail="month"
          onClickDay={(val) => onChange("date", val)}
          tileClassName={(val) => (isToday(val.date) ? "react-calendar__tile--today" : "")}
          value={date ? moment(date).toDate() : null}
        />
        {!isTimeHidden && (
          <div className={styles.right}>
            <TimePicker hasDate={!!date} onChange={(val) => onChange("time", val)} time={time} />
            <SubmitButton isDisabled={!date} onSubmit={onSave} submitLabel={t("set")} />
          </div>
        )}
      </div>
    </div>
  );
};

DateTimePicker.propTypes = {
  date: PropTypes.instanceOf(Date),
  time: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  isTimeHidden: PropTypes.bool,
};

DateTimePicker.defaultProps = {
  title: t("title"),
};

export default DateTimePicker;
